import { createUseStyles } from 'react-jss';
import { colors } from "../../../utils";


var styles = {
  text: {
    font: { weight: 400, size: '1.6rem', lineHeight: '2.4rem' },
    '& a': {
      color: colors.blue[600]
    },
    margin: {
      bottom: '2.4rem'
    }
  },
  prefix: {
    display: 'block',
    font: { weight: 700, size: '1.6rem', lineHeight: '2.4rem' },
    textTransform: 'uppercase',
    color: colors.orange[600],
    marginRight: '0.8rem',
    width: '10.4rem'
  },
  wrapper: function wrapper(props) {return {
      display: 'flex',
      maxWidth: '75.2rem',
      alignItems: 'top',
      margin: { top: props.prefix && '0.8rem' }
    };}
};

var createStyles = createUseStyles(styles);

export default createStyles;
//# sourceMappingURL=styles.js.map